import React from 'react';

import {Modal, ModalHeader, ModalBody} from 'Components/Modal';

class ViewServiceDocumentModal extends React.Component {
    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const { pdfUrl, title } = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    {title ?? ''}
                </ModalHeader>
                    <ModalBody>
                        {pdfUrl &&
                            // Use <object> with embed fallback and a download/open link for mobile
                            // Many mobile browsers have inconsistent iframe PDF support; using object/embed
                            // and providing a link to open in a new tab improves multi-page viewing.
                            <div className="w-full max-w-4xl mx-auto my-6" style={{ minHeight: '400px' }}>
                                <object
                                    data={ pdfUrl + "#toolbar=0" }
                                    type="application/pdf"
                                    className="w-full h-[80vh]"
                                    aria-label={title ?? 'Document'}
                                >
                                    <embed src={ pdfUrl } type="application/pdf" className="w-full h-[80vh]" />
                                    <div className="p-4">
                                        <p>Unable to display PDF in your browser.</p>
                                        <p>
                                            <a href={ pdfUrl } target="_blank" rel="noopener noreferrer">Open document in a new tab</a>
                                        </p>
                                    </div>
                                </object>
                            </div>
                        }
                    </ModalBody>
            </Modal>
        );
    }
}

export default ViewServiceDocumentModal ;
